module.exports = __webpack_public_path__ + "img/fb.c5b90bc9.png";